import React, { useState, useEffect } from 'react';
import { Spin, Typography, Card, Pagination } from 'antd';
import './HerbivoreOptions.css';

const { Title, Text } = Typography;

const HerbivoreOptions = ({ data, loading }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(6);

  // Dynamically update pageSize based on screen width
  useEffect(() => {
    const updatePageSize = () => {
      setPageSize(window.innerWidth > 1600 ? 12 : 6);
    };

    updatePageSize(); // Set initial value
    window.addEventListener('resize', updatePageSize);

    return () => {
      window.removeEventListener('resize', updatePageSize);
    };
  }, []);

  // Calculate items for the current page
  const startIndex = (currentPage - 1) * pageSize;
  const currentItems = data.slice(startIndex, startIndex + pageSize);

  return (
    <div className="herbivore-container">
      <Title level={4} className="herbivore-title">Herbivore Camera Data (Top 50)</Title>

      {loading ? (
        <div className="spinner-container">
          <Spin size="large" />
        </div>
      ) : (
        <>
          <div className="card-list">
            {currentItems.map((item) => (
              <Card
                key={item.camera_id}
                className="camera-card"
                bordered
                hoverable
              >
                <Text className="camera-name">{item.camera_name}</Text>
                <br />
                <Text>lat: {item.latitude.toFixed(5)}</Text>
                <br />
                <Text>lng: {item.longitude.toFixed(5)}</Text>
                <br />
                <Text>Herbivores: {item.herb_count}</Text>
              </Card>
            ))}
          </div>

          <div className="pagination-container">
            <Pagination
              current={currentPage}
              pageSize={pageSize}
              total={data.length}
              onChange={(page) => setCurrentPage(page)}
              showSizeChanger={false}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default HerbivoreOptions;
